<template>
	<div class="userpage" :class="$store.state.mode">
		<div class="navbar" :class="($store.state.mode === 'dark') ? 'darkModeActive' : 'false'">
			<i v-on:click="$router.go(-1)" class="material-icons">arrow_back</i>
			<div class="title">Creator</div>
			<i @click="open" class="material-icons">error_outline</i>		
		</div>
		<div class="profile--wrapper">
			<div class="profile">
				<div
				class="image-profile"
				:class="($store.state.mode === 'dark') ? 'darkModeActive' : 'false'"
				:style="{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 1)), url(${cover})` }"
				></div>
				<div class="details">
					<a class="name">
						{{ creator }}
						<div class="verified--wrapper">
							<img v-if="verified" src="@/assets/icons/verified.png" class="verify">
						</div>
					</a>
					<a class="bio" :class="($store.state.mode === 'dark') ? 'darkModeActive' : 'false'" >
						{{ bio }}
					</a>
				</div>
				<div class="subs--wrapper" v-if="isSubsActive != null">
					<div class="subs-count">{{ subscriber }} Subscribers</div>
					<div v-ripple class="subs" :class="[{'isActive': isSubsActive}, ($store.state.mode === 'dark') ? 'darkSubscribe' : 'false']">
						<div v-if="!isSubsActive" @click="subscribe()">
							Subscribe
						</div>
						<div v-else @click="unsubscribe()">
							Subscribed
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- Episodes -->
		<div v-if="audioPlaylist.length > 0" class="heading">
			<div class="title">Available episodes</div>
			<div class="subtitle">by latest upload</div>
		</div>
		<div v-for="(item, index) in audioPlaylist" :key="index" :class="{'active' : $store.state.isPlaying == item.audio}" class="playlist--wrapper">
			<div class="audio--wrapper">
				<div @click="play(item.audio)" class="title">{{ item.title }}</div>
				<div class="date" :class="($store.state.mode === 'dark') ? 'darkDate' : 'false'">{{ humanDate(item.created_at.toDate()).fromNow() }}
					<div :class="{'active' : $store.state.isPlaying == item.audio}" class="dot"></div> {{ timeConvert(item.duration) }} min
				</div>
			</div>
			<div class="playbtn--wrapper">
				<div style="width: 24px;height: 24px; border-radius:50%" v-ripple v-if="$store.state.isStoping == item.audio" @click="play(item.audio)">
					<i style="border-radius: 50%" class="material-icons">play_circle_outline</i>
				</div>
				<div style="width: 24px;height: 24px; border-radius:50%" v-ripple v-else-if="$store.state.isPlaying == item.audio" @click="pause(item.audio)">
					<i style="border-radius: 50%" class="material-icons">pause_circle_outline</i>
				</div>
				<div style="width: 24px;height: 24px; border-radius:50%" v-ripple v-else @click="play(item.audio)">
					<i style="border-radius: 50%" class="material-icons">play_circle_outline</i>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import db from '@/db'
import firebase from 'firebase'
export default {
	data() {
		return {
			isReportActive: false,
			isSubsActive: null,
			creator: null,
			cover: null,
			bio: null,
			verified : false,
			subscriber : 0,
			audioPlaylist: [],
		}
	},
	methods: {
		refreshData() {
			let _this = this
			this.isReportActive= false,
			this.isSubsActive= null,
			this.creator= null,
			this.cover= null,
			this.bio= null,
			this.verified = false,
			this.subscriber = 0,
			this.audioPlaylist= [],
			db.collection('subscriber').where('uid','==',this.$store.state.currentUser.uid).where('cid','==',this.$route.params.id).limit(1).get().then((subscribe) => {
				if (subscribe.size == 1) {
					_this.isSubsActive = true
				}else {
					_this.isSubsActive = false
				}
			})
			db.collection('creator').doc(this.$route.params.id).get().then((creator) => {
				_this.creator = creator.data().podcastName
				_this.bio = creator.data().bio
				_this.verified = creator.data().verified
				_this.cover = creator.data().cover
				_this.subscriber = creator.data().subscriber
			})
			db.collection('episodes').where('uid','==',this.$route.params.id).orderBy('created_at','desc').get().then((episodes) => {
				episodes.forEach((episode) => {
					_this.audioPlaylist.push(episode.data())
				})
			})
		},
		open() {
			window.open('mailto:djourneyofadam@gmail.com','_blank')
			// const h = this.$createElement
			// this.$prompt(null,'', {
			// 	message: h('p', {style: 'font-family: GoogleSans'} , [
			// 		h('h4', null, 'Report this account, tell us why'),
			// 		]),

			// 	confirmButtonText: 'OK',
			// 	cancelButtonText: 'Cancel',
			// 	inputErrorMessage: 'Invalid Input',
			// 	center: true,

			// 	beforeClose: (action, instance, done) => {
			// 		if (action === 'confirm') {
			// 			instance.confirmButtonLoading = true;
			// 			instance.confirmButtonText = 'Loading...';
			// 			setTimeout(() => {
			// 				done();
			// 				setTimeout(() => {
			// 					instance.confirmButtonLoading = false;
			// 				}, 300)
			// 			}, 1000)
			// 		} else {
			// 			done()
			// 		}
			// 	}
			// }).then(({ value }) => {
			// 	this.$message({
			// 		type: 'success',
			// 		message: 'Report successful ' + value
			// 	})
			// })
		},
		play: function(audioUrl) {
			this.$store.commit('playSound', audioUrl)
		},
		pause: function(audioUrl) {
			this.$store.commit('pauseSound', audioUrl)
		},
		subscribe() {
			let _this = this
			this.isSubsActive = true
			let increment = firebase.firestore.FieldValue.increment(+1)
			db.collection('subscriber').add({
				uid: this.$store.state.currentUser.uid,
				cid: this.$route.params.id
			})
			db.collection('creator').doc(_this.$route.params.id).update({
				subscriber: increment
			}).then(() => {
				_this.subscriber++
			})
		},
		unsubscribe() {
			let _this = this
			this.isSubsActive = false
			let decrement = firebase.firestore.FieldValue.increment(-1)
			db.collection('subscriber').where('uid','==',this.$store.state.currentUser.uid).where('cid','==',this.$route.params.id).get().then((docs) => {
				docs.forEach((doc) => {
					db.collection('subscriber').doc(doc.id).delete()
					db.collection('creator').doc(_this.$route.params.id).update({
						subscriber: decrement
					})
					_this.subscriber--
				})
			})
		}
	},
	activated() {
		this.refreshData()
	}
};
</script>
<style lang="scss" scoped>
$base-color: #1b7b46;
$inner-color: #caefe2;
$accent-color: #2fca74;
.heading {
	margin: 2rem 1.5rem .7rem;
	.title {
		font-size: 18px;
		font-weight: bold;
		letter-spacing: -.5px;
	}
	.subtitle {
		opacity: .5;
		font-size: 12px;
		text-transform: lowercase;
	}
}
.userpage {
	position: absolute;
	width: 100%;
	padding-bottom: 3.4rem;
	background: #fff;
	color: #000;
}
/* DARK MODE */
.dark {
	background: #000;
	color: #fff;
}
/* HEADER */
.navbar.false {
	background-image: linear-gradient(rgb(255,255,255), rgb(255,255,255));
	box-shadow: 0 1px 10px rgba(0,0,0, .03);
}
.navbar {
	z-index: 99;
	position: fixed;
	width: 100%;
	height: 4rem;
	padding: 0 1.5rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	backdrop-filter: blur(1px);
	background-image: linear-gradient(rgb(0,0,0), transparent);
	.title {
		font-size: 14px;
	}
}
.profile--wrapper {
	padding: 5rem 1.5rem 2rem;
	border-bottom: 1px solid rgba(255,255,255, .1);
	.profile {
		display: flex;
		flex-direction: column;
		align-items: center;
		.verified--wrapper {
			height: 24px;
			display: flex;
			align-items: center;
			.verify {
				height: 14px;
				margin-left: .20rem;
			}
		}
		.image-profile {
			width: 150px;
			height: 150px;
			border-radius: 50%;
			background-size: cover;
			background-position: center;
		}
		.details {
			width: 100%;
			padding: 1rem 0;
			display: flex;
			flex-direction: column;
			align-items: center;
			text-align: center;
			.name {
				display: flex;
				font-size: 24px;
				letter-spacing: -.5px;
				font-weight: bold;
			}
			.bio {
				padding: .2rem 0;
				font-size: 12px;
				opacity: .5;
				letter-spacing: .2px;
			}
		}
		.subs--wrapper {
			width: 100%;
			padding: 0 4rem;
			display: flex;
			justify-content: space-around;
			align-items: center;
			.subs.darkSubscribe {
				color: $accent-color;
				background-color: rgba($base-color, .15);
			}
			.subs {
				z-index: 98;
				display: flex;
				border-radius: 12px;
				font-size: 12px;
				font-weight: bold;
				padding: .75rem 1.5rem;
				transition: .25s ease-in-out;
				color: $accent-color;
				background-color: rgba($base-color, .1);
				&.isActive {
					color: rgba($accent-color, .7);
					border: 1px solid rgba(27, 123, 70, 0.25);
					background-color: transparent;
				}
			}
			.subs-count {
				font-size: 12px;
				opacity: .5;
				text-transform: lowercase;
			}
		}
	}
}
.playlist--wrapper {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1.5rem 1rem;
	border-bottom: 1px solid rgba(255,255,255, .1);
	transition: 1s;
	&.active {
		background: linear-gradient(90deg, rgba(27, 123, 70, 0.35), transparent);
	}
	&:active {
		opacity: .5;
	}
	.audio--wrapper {
		padding: 0 .5rem;
		.title {
			font-size: 12px;
			padding-bottom: .5rem;
		}
		.date {
			font-size: 10px;
			font-weight: normal;
			opacity: .8;
			.dot {
				margin: 1px 2px;
				width: 3px;
				height: 3px;
				background-color: rgba(27, 123, 70, 1);
				border-radius: 50%;
				display: inline-block;
				&.active {
					animation: pulsate 1.5s ease-out;
					animation-iteration-count: infinite;
					opacity: 1;
					@-webkit-keyframes pulsate {
						0% {-webkit-transform: scale(0.1, 0.1); opacity: 0.0;}
						50% {opacity: 1.0;}
						100% {-webkit-transform: scale(1.2, 1.2); opacity: 0.0;}
					}
				}
			}
		}
	}
	.playbtn--wrapper {
		padding: 0 .5rem;
	}
}
</style>